export default "__VITE_ASSET__DaVCOiBV__"